import blAuth from '@/connection/bl-auth/bl-auth';
import { store } from '@/store/main';
import { globalRouteContext } from '@/store/router-context';
import { loadChannels } from '@/store/slices/channels';
import { fetchGreenroomToken, setAuthTokens } from '@/store/slices/user';
import getUserFromToken from '@/store/slices/user/helpers/get-user-from-token';
import { getActiveChannel, selectUser } from '@/store/slices/user/selectors';
import { getThemeForCurrentLocation } from '@/utils/get-theme-for-current-location';
import type { LoaderFunctionArgs, MiddlewareFunction } from 'react-router-dom';

export const mainMiddleware: MiddlewareFunction = async ({ context }: LoaderFunctionArgs) => {
  try {
    const state = store.getState();
    const user = selectUser(state);
    if (!user) {
      await blAuth.handleRedirected();

      if (blAuth.refreshToken) {
        await blAuth.refresh();
        blAuth.initializeActivityTracker({ refreshOnInterval: true });
      } else {
        const theme = getThemeForCurrentLocation();
        blAuth.redirectToSignIn({ redirect_uri: window.location.href, theme });
        return;
      }

      const user = blAuth.idToken ? getUserFromToken(blAuth.idToken) : undefined;
      if (user) {
        context.set(globalRouteContext, { channel: user.active_channel });
      }
      store.dispatch(
        setAuthTokens({
          idToken: blAuth.idToken as string,
          refreshToken: blAuth.refreshToken as string,
        })
      );
      store.dispatch(fetchGreenroomToken());
      store.dispatch(loadChannels({ useCache: true }));
    }

    const channel = getActiveChannel(state);
    if (channel) {
      context.set(globalRouteContext, { channel });
    }
  } catch (e) {
    console.error(e);
  }
};
